import { getElements, ifSelectorExist } from "./utils";

export const signatureBlockAnimation = () => {
    let targetSection = getElements('.animation-line');
    if (ifSelectorExist(targetSection)) {

        let signatureAnimation = (item) => {
            let sectionPosition = item.getBoundingClientRect();
            if (sectionPosition.top <= (window.innerHeight || document.documentElement.clientHeight)
                && sectionPosition.bottom >= 0) {
                item.classList.add('run-animation');
            }
        }

        Array.from(targetSection).forEach(item => {

            // also check if page already scrolled to run animation.
            signatureAnimation(item);

            // Check if user see the block we need.
            window.addEventListener('scroll', function () {
                signatureAnimation(item);
            });
        })
    }
}
